module.exports = __webpack_public_path__ + "img/img_baby_app_3_en.0a675a0f.png";